/**
 * @file Homepage Coverage
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Homepage Coverage component
 */
const vHpCoverage = () => {
	const hpCoverage = document.querySelector('.v-hp-coverage');

	if (!hpCoverage) {
		return;
	}

	gsap.registerPlugin(ScrollToPlugin);

	const moreBtn = hpCoverage.querySelector('.v-hp-coverage__more-btn');
	const list = hpCoverage.querySelector('.v-hp-coverage__list');
	const overflow = hpCoverage.querySelectorAll('[data-overflow]');
	let isAnimating = false;

	/**
	 * Toggle the coverage open or closed
	 */
	const toggleCoverage = () => {
		if (isAnimating) {
			return;
		}

		const isOpen = moreBtn.getAttribute('aria-expanded') === 'true';

		const tl = gsap.timeline({
			defaults: {
				ease:     'sine.out',
				duration: 1.25,
			},
			onStart: () => {
				isAnimating = true;
			},
			onComplete: () => {
				isAnimating = false;
			},
		});

		const listHeight = list.getBoundingClientRect().height;

		if (isOpen) {
			const btnOffset = moreBtn.getBoundingClientRect().top;
			[...overflow].forEach((item) => item.classList.add('v-hp-coverage__item--hidden'));
			const targetHeight = list.getBoundingClientRect().height;
			[...overflow].forEach((item) => item.classList.remove('v-hp-coverage__item--hidden'));

			const heightDiff = targetHeight - listHeight;

			tl
				.to(list, {
					height:     targetHeight,
					onComplete: () => {
						moreBtn.setAttribute('aria-expanded', 'false');
						[...overflow].forEach((item) => item.classList.add('v-hp-coverage__item--hidden'));
						list.removeAttribute('style');
					},
				});

			if (Math.abs(heightDiff) > Math.abs(btnOffset) + 100) {
				tl
					.to(window, {
						scrollTo: window.scrollY + heightDiff,
					}, '<');
			}
		} else {
			[...overflow].forEach((item) => item.classList.remove('v-hp-coverage__item--hidden'));
			const targetHeight = list.getBoundingClientRect().height;
			gsap.set(list, { height: listHeight });
			tl
				.to(list, {
					height:  targetHeight,
					onStart: () => {
						moreBtn.setAttribute('aria-expanded', 'true');
					},
					onComplete: () => {
						list.removeAttribute('style');
					},
				});
		}
	};

	moreBtn.addEventListener('click', toggleCoverage);
};

export default vHpCoverage;
